import type { ApiToBridgeSessionGitChangesPayload } from '../../../types/api-to-bridge-messages.js';

export type ParsedSessionGitChangesParams = {
  repoRelPath: string;
  view: 'working' | 'commit';
  commitSha: string;
  recentCommitsLimit?: number | string;
  fileWorkspaceRelPath: string;
  fileChange: string;
  fileMovedFromWorkspaceRelPath: string;
};

function readString(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

function readChangesObject(msg: Record<string, unknown>): ApiToBridgeSessionGitChangesPayload | null {
  const changes = msg.changes;
  if (!changes || typeof changes !== 'object' || Array.isArray(changes)) return null;
  return changes as ApiToBridgeSessionGitChangesPayload;
}

/** Prefer nested `changes`; fall back to legacy flat list fields only (not file paths). */
export function parseSessionGitChangesParams(msg: Record<string, unknown>): ParsedSessionGitChangesParams {
  const nested = readChangesObject(msg);
  const file =
    nested?.file && typeof nested.file === 'object' && !Array.isArray(nested.file) ? nested.file : null;

  const repoRelPath =
    readString(nested?.repoRelPath) || readString(msg.changesRepoRelPath);
  const viewRaw = nested?.view ?? msg.changesView;
  const view = viewRaw === 'commit' ? 'commit' : 'working';
  const commitSha = readString(nested?.commitSha) || readString(msg.changesCommitSha);
  const recentCommitsLimit = nested?.recentCommitsLimit ?? msg.changesRecentCommitsLimit;

  return {
    repoRelPath,
    view,
    commitSha,
    recentCommitsLimit:
      typeof recentCommitsLimit === 'number' || typeof recentCommitsLimit === 'string'
        ? recentCommitsLimit
        : undefined,
    fileWorkspaceRelPath: readString(file?.workspaceRelPath),
    fileChange: readString(file?.change),
    fileMovedFromWorkspaceRelPath: readString(file?.movedFromWorkspaceRelPath),
  };
}
